<div class="pdf-viewer-container">
<!--  <div class="pdf-mobile-fallback" *ngIf="isMobile && pdfUrl">-->
<!--    <p>PDF документ готов к просмотру</p>-->
<!--    <a [href]="pdfUrl" target="_blank" download="voucher.pdf" class="download-button">-->
<!--      📱 Открыть PDF-->
<!--    </a>-->
<!--    <p class="mobile-hint">Нажмите для открытия в отдельном окне</p>-->
<!--  </div>-->

  <!-- Iframe для десктопов -->
  <iframe
    #theFrame
    *ngIf="safePdfUrl && !hasError"
    [src]="safePdfUrl"
    class="pdf-iframe"
    frameborder="0"
    (load)="onLoad()"
    (error)="onError()"
    type="application/pdf">
  </iframe>
<!--  <div class="pdf-error" *ngIf="hasError">-->
<!--    <p>Не удалось загрузить PDF файл</p>-->
<!--    <a [href]="pdfUrl" download="voucher.pdf" class="download-link">-->
<!--      📥 Скачать файл-->
<!--    </a>-->
<!--    <button (click)="reloadPdf()" class="retry-button">-->
<!--      🔄 Попробовать снова-->
<!--    </button>-->
<!--  </div>-->
<!--  <div class="pdf-loading" *ngIf="isLoading">-->
<!--    <div class="loading-spinner"></div>-->
<!--    <p>Загрузка PDF...</p>-->
<!--  </div>-->
</div>
